import { useQuery, useMutation } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

export const useTimeSlotCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/time-slot/`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slots Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ time-slots create request failed:", error.message);
    },
  });
};

export const useFetchTimeSlotData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  return useQuery({
    queryKey: ["timeSlotData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/time-slot?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};
interface UpdateTimeSlotPayload {
  id: string;
  type: string;
  slotName: string;
  days: any;
  startTime: Date;
  endTime: Date;
}
export const useUpdateTimeSlot = () => {
  return useMutation({
    mutationFn: async ({
      id,
      type,
      slotName,
      days,
      startTime,
      endTime,
    }: UpdateTimeSlotPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/time-slot/${id}`,
        "PUT",
        {
          type,
          slotName,
          days,
          startTime,
          endTime,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slot update successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ time-slot update request failed:", error.message);
    },
  });
};

interface UpdateTimeSlotStatusPayload {
  id: string;
  status: any; // Add more statuses if needed
}
export const useUpdateTimeSlotStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdateTimeSlotStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/time-slot/${id}`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ time-slot status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ time-slot status update failed:", error.message);
    },
  });
};

export const useFetchStaffsTimeSlotAllData = () => {
  return useQuery({
    queryKey: ["staffsTimeSlotAllData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/time-slot/all/by-type/Staff`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: true,
    staleTime: 1000 * 60 * 5,
  });
};
export const useFetchDriverTimeSlotAllData = () => {
  return useQuery({
    queryKey: ["driverTimeSlotAllData"],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/time-slot/all/by-type/Driver`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    enabled: true,
    staleTime: 1000 * 60 * 5,
  });
};
